import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import { AirportService } from '../../airport/airport.service';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
var BusinessResolver = /** @class */ (function () {
    function BusinessResolver(document, _router, _airportService, _errorHandler, _toggleService) {
        this.document = document;
        this._router = _router;
        this._airportService = _airportService;
        this._errorHandler = _errorHandler;
        this._toggleService = _toggleService;
    }
    BusinessResolver.prototype.resolve = function (route, state) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, business, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        id = route.paramMap.get('id');
                        return [4 /*yield*/, this._airportService.getBusiness(id)];
                    case 1:
                        business = _a.sent();
                        this._toggleService.setState(false);
                        if (business) {
                            return [2 /*return*/, business];
                        }
                        this._router.navigate(['/404']);
                        return [2 /*return*/, null];
                    case 2:
                        e_1 = _a.sent();
                        this._errorHandler.handleError(e_1);
                        this._router.navigate(['/500']);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return BusinessResolver;
}());
export { BusinessResolver };
